module.exports = __webpack_public_path__ + "static/media/country_pg.8b4f78f1.webp";